import CarouselLinks from 'shared/assets/scripts/carouselLinks'

export default class HeaderTopbar {
	private headerNavbar: HTMLElement | null

	constructor() {
		this.headerNavbar = document.querySelector('.headerNavbar-scrollWrapper')
	}

	init() {
		if (this.headerNavbar) {
			const carouselLinks = new CarouselLinks(this.headerNavbar)
			carouselLinks.init()
		}
	}
}
